<template>
    <div :class="['popup_basic01 top', this.aptSelState? 'close' : 'open']" :style="selectedLfcnvncTab == 'apart' ? '' : 'display:none;'">
        <div class="popup_wrap2 he280">
            <div class="sel_area">
                <!-- <div class="sel_control" @click.prevent="changeAptSelState()"><a href="">닫기</a></div> -->

                <h2 class="optionT"></h2>

                <div v-if="!aptSelState">
                    <div class="quarter_select" style="cursor: pointer;">
                        <select v-model="selectedDong">
                            <option v-bind:value="value" v-for="value in selectionList">{{ value }}</option>
                        </select>
                        <div class="select_arrow"></div>
                    </div>
                    <div class="quarter_select" style="cursor: pointer;">
                        <select v-model="selectedDate">
                            <option v-bind:value="key" v-for="(key) in selectMap[selectedDong]">{{ key }}</option>
                        </select>
                        <div class="select_arrow"></div>
                    </div>
                </div>

                <div class="sel_option" v-if="aptSelState">
                    <p class="sel_tit">선택한 옵션 적용</p>
                    <p class="sel_icon">
                        <a href="javascript: void(0);" class="on" @click.prevent="changeAptSelState()"><i class="sel_i13"></i>
                            아파트
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_WC, $_TYPE, $_ADM } from '@/confs/common.const.js';

export default {
    data() {
        return {
            aptSelState: false,
            selectedDong: '도곡동',
            naverMaps: undefined,
        }
    },
    components: {
    },
    watch: {
        selectedDong: {
            immediate: false,
            handler(newVal, oldVal) {
                // this.$store.dispatch('SET_SELECTED_DATE', this.selectMap[newVal][0]);
                if(typeof this.curInfoWindow !== $_TYPE.UNDEF) {
                    this.curInfoWindow.close();
                }
                this.$eventBus.$emit("Change::Dong", newVal);
                let legdongCd = $_ADM.LEGDONG_NM_MAP[newVal];
                let position = new naver.maps.LatLng($_ADM.LEGDONG_CENTER_MAP[legdongCd].lat, $_ADM.LEGDONG_CENTER_MAP[legdongCd].lng);
                this.naverMaps.setCenter(position);
                this.naverMaps.setZoom(15);
            }
        },
    },
    created() {
        this.$eventBus.$once('NaverMap::map-loaded', map => {
            this.naverMaps = map;
        });
        this.$eventBus.$on("Change::Dong", (dong) => {
            this.selectedDong = dong;
        });
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
            // selectedDate: 'getSelectedDate',
            selectMap: 'getSelectMap',
            aptMap: 'getAptMap',
            apartMap: 'getApartMap',
        }),
        // 아파트 명
        selectedDate: {
            get() { return this.$store.getters.getSelectedDate; },
            set(value) { this.$store.dispatch('SET_SELECTED_DATE', value); }
        },
        selectionList() {
            let list = [];
            for(let addong in this.apartMap) {
                list.push(addong);
            }
            return list;
        },
    },
    methods: {
        changeAptSelState() {
            this.aptSelState = !this.aptSelState;
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
